var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scp-eval" },
    [
      !_vm.loading
        ? [
            _vm.evaluation.missingRequiredSlots.length
              ? _c(
                  "div",
                  {
                    staticClass: "scp-eval-callout",
                    attrs: { role: "status" },
                  },
                  [
                    _vm._v(
                      " Missing " + _vm._s(_vm.missingRequiredSlotsLabel) + " "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "scp-eval-rubric" },
              _vm._l(_vm.rubricAxes, function (axis) {
                return _c(
                  "div",
                  { key: axis.id, staticClass: "scp-eval-axis" },
                  [
                    _c("div", { staticClass: "scp-eval-axis-head" }, [
                      _c("span", { staticClass: "scp-eval-axis-title" }, [
                        _vm._v(_vm._s(axis.label)),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "scp-eval-axis-rating",
                          class: { "is-unscored": !axis.data.scored },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                axis.data.scored
                                  ? axis.data.rating
                                  : "Unscored — insufficient basis"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c("p", { staticClass: "scp-eval-axis-rationale" }, [
                      _vm._v(_vm._s(axis.data.rationale)),
                    ]),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "scp-eval-slots" },
              [
                _vm._l(_vm.requiredSlots, function (slot) {
                  return _c(
                    "div",
                    { key: slot.id, staticClass: "scp-eval-slot" },
                    [
                      _c("span", { staticClass: "scp-eval-slot-label" }, [
                        _vm._v(_vm._s(slot.label)),
                      ]),
                      _c("span", { staticClass: "scp-eval-slot-value" }, [
                        _vm._v(" " + _vm._s(slot.data.value || "—") + " "),
                        slot.data.resolvedId &&
                        slot.data.resolvedId !== slot.data.value
                          ? _c(
                              "span",
                              { staticClass: "scp-eval-slot-resolved" },
                              [
                                _vm._v(
                                  " → " + _vm._s(slot.data.resolvedId) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        slot.id === "outcome" && slot.data.factorSearchQuery
                          ? _c(
                              "span",
                              { staticClass: "scp-eval-slot-factor-query" },
                              [
                                _vm._v(
                                  " Factor search: " +
                                    _vm._s(slot.data.factorSearchQuery) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "scp-eval-slot-confidence",
                          class: `is-${slot.data.confidence}`,
                        },
                        [_vm._v(" " + _vm._s(slot.data.confidence) + " ")]
                      ),
                    ]
                  )
                }),
                _vm._l(_vm.modifierSlots, function (slot) {
                  return _c(
                    "div",
                    { key: slot.id, staticClass: "scp-eval-slot" },
                    [
                      _c("span", { staticClass: "scp-eval-slot-label" }, [
                        _vm._v(_vm._s(slot.label)),
                      ]),
                      _c("span", { staticClass: "scp-eval-slot-value" }, [
                        _vm._v(_vm._s(slot.data.value || "—")),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "scp-eval-slot-confidence",
                          class: `is-${slot.data.confidence}`,
                        },
                        [_vm._v(" " + _vm._s(slot.data.confidence) + " ")]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }